import React, { useEffect, useState } from 'react';
import { Box, Card, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import '../Teams/Teams.css';
import UsersAddEditForm from './UsersAddEditForm/UsersAddEditForm';
import TableView from './TableView/TableView';
import { connect } from 'react-redux';
import './Users.css'
import CustomTheme from '../../../../utilities/theme/theme.json'
import NoUserFound from './UserLandingPage/UserLandingPage';
import { getAllAuthUsersRequest } from '../../../authentication/AuthenticationApiActions'
const Users = ({
    allUsers,
    getAllAuthUsers
}) => {
    const [showNewUserForm, setShowNewUserForm] = useState(false)
    const [rowIndex, setRowIndex] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [addNewUser, setAddNewUser] = useState(false)
    useEffect(() => {
        getAllAuthUsers(false).then((res) => {
            if (res.length !== 0) {
                setShowNewUserForm(true)
            } else { }
        })
    }, [])

    return (
        <>
            {
              (allUsers &&  allUsers.length !== 0) || showNewUserForm
                    ?
                    <Box>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                                <Card className="new-team-list">
                                    <Grid container justify="space-between"
                                        style={{ borderBottom: `1px dashed ${CustomTheme.primaryColor}` }} spacing={0}
                                        className='table-title-style'>
                                        <Grid>
                                        </Grid>
                                        <Grid>
                                            <Box className="header-buttons-in-list">
                                                <Button size="small"
                                                    onClick={() => {
                                                        setSelectedRow(null);
                                                        setAddNewUser(true);
                                                        setRowIndex(null);
                                                    }}
                                                    variant="outlined"
                                                    color="primary"
                                                    className="blank-page-button-milestone margin-top-team-btn"><i
                                                        className="fas fa-user"></i> <span className="btn-margin-left"> + USER</span>
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <TableView
                                        setSelectedRow={setSelectedRow}
                                        selectedRow={selectedRow}
                                        setRowIndex={setRowIndex}
                                        setAddNewUser={setAddNewUser}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                                {
                                    selectedRow != null || addNewUser
                                        ?
                                        <Card className="new-team-detail-panel">
                                            <UsersAddEditForm
                                                setRowIndex={setRowIndex}
                                                rowIndex={rowIndex}
                                                addNewUser={addNewUser}
                                                setAddNewUser={setAddNewUser}
                                                setSelectedRow={setSelectedRow}
                                            />
                                        </Card>
                                        :
                                        <></>
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    :
                    <NoUserFound setShowNewUserForm={setShowNewUserForm} setAddNewUser={setAddNewUser} />
            }
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        loggedInUser: state.auth.loggedInUser,
        allUsers: state.auth.users

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllAuthUsers: (isLoaderShowing) => {
            return dispatch(getAllAuthUsersRequest(isLoaderShowing)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
